import request from 'common/Requst/axios';

export const ApplyApi = (data) =>
  request.post("/activity-server/invitation/add", data);